export default {
  name: "VerifyCode",
  path: "/verify",
  component: () => import("@/views/Verification")
};
